<template>
    <div :class="`lab-card-equipment lab-card-equipment--${modifier}`">
        <div class="lab-card-equipment__rating">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.0013 0.930664L8.95797 4.926L13.3346 5.57066L10.168 8.67866L10.9153 13.0693L7.0013 10.9953L3.0873 13.0693L3.83464 8.67866L0.667969 5.57066L5.04397 4.926L7.0013 0.930664Z" fill="#C39B70"/>
            </svg>
            <span>{{ protectedRating }}</span>
        </div>

        <div class="lab-card-equipment__image">
            <template v-if="modelPicture">
                <img :src="modelPicture" :alt="cardName">
            </template>
            <template v-else-if="customPicture">
                <img :src="customPicture" :alt="cardName">
                <div
                    data-toggle="tooltip"
                    data-html="true"
                    title="<div class='tooltip-body'>Изображения этого оборудования у нас пока нет, но мы это исправим.<br>После модерации здесь появится изображение вашего оборудования.</div>"
                    class="lab-card-equipment__tooltip lab-card-equipment__tooltip--castom"
                    @click.stop
                >
                    <div class="pulse-spot"></div>
                </div>
            </template>
            <template v-else-if="slotPicture">
                <img :src="slotPicture" :alt="cardName">
                <div class="lab-card-equipment__tooltip pulse-spot"></div>
            </template>
        </div>
        <div class="lab-card-equipment__name">{{ cardName || equipmentSlot.NAME }}</div>
    </div>
</template>

<script>

export default {
    name: 'lab-card-equipment',

    data() {
        return {
            brand: null,
            model: null,
        };
    },

    props: {
        equipmentSlot: {
            type: Object,
        },

        /**
         * Тип лаборатории
         */
        forWhoId: {
            type: String,
        },

        /**
         * Тип лаборатории
         */
        cookingTypeId: {
            type: String,
        },

        /**
         * @type {LabFormDataEquipment}
         */
        equipmentSelected: {
            type: Object,
        },

        equipmentRating: {
            type: [String],
            required: false,
        },

        modifier: {
            type: String,
            default: 'default',
        },
    },

    computed: {
        brandName() {
            return this.brand ? this.brand.NAME : this.equipmentSelected?.MODEL_NEW;
        },

        modelName() {
            return this.model ? this.model.NAME : '';
        },

        cardName() {
            // return this.brandName && this.modelName ? `${this.brandName} (${this.modelName})` : null;
            let name = '';

            if (this.brandName) {
                name = `${this.brandName}`;
            }

            if (this.brandName && this.modelName) {
                name = `${this.brandName} (${this.modelName})`;
            }

            return name;
        },

        modelPicture() {
            return this.model?.PREVIEW_PICTURE?.SRC;
        },

        customPicture() {
            // если есть кастомное свойство, то UF_PICTURE_UNKNOWN
            return this.equipmentSelected?.MODEL_NEW ? this.equipmentSlot?.UF_PICTURE_UNKNOWN?.SRC : null;
        },

        slotPicture() {
            return this.equipmentSlot?.UF_PICTURE?.SRC;
        },

        // сначала проверяем пропс сверху и если его нет, берём рейтинг модели
        protectedRating() {
            let rating = 0;
            let ratingValues = [];

            if (this.equipmentRating) {
                ratingValues = this.equipmentRating;
            } else if (this.model?.PROPERTIES?.rating?.VALUE) {
                ratingValues = this.model.PROPERTIES.rating.VALUE;
            }

            const { RATING: ratings } = ratingValues;

            if (!this.cookingTypeId || !this.forWhoId || !ratings) {
                return rating;
            }

            const { cookingTypeId, forWhoId } = this;
            const isHasRating = ratings[cookingTypeId] && Object.prototype.hasOwnProperty.call(ratings[cookingTypeId], forWhoId);

            rating = isHasRating ? ratings[cookingTypeId][forWhoId] : 0;

            return rating;
        },
    },

    methods: {
        setData() {
            const brandId = this.equipmentSelected?.BRAND;
            const modelId = this.equipmentSelected?.MODEL;

            this.brand = this.equipmentSlot.BRANDS[brandId];
            this.model = this.brand ? this.brand.MODELS[modelId] : null;
        },
    },

    created() {
        this.setData();
    },

    watch: {
        equipmentSelected() {
            this.setData();
        },
    },
};
</script>
